export const AUTHEN = 'AUTHEN';
export const DATA_SHOP = 'DATA_SHOP';